if (!customElements.get('download-dieline')) {
  customElements.define(
    'download-dieline',
    class DownloadDieline extends HTMLElement {
      constructor() {
        super();

        this._isValid = false;
        this.fetching = false;

        this.variantSelects = document.querySelector('variant-selects');
        this.sizeDropdown = document.querySelector('size-dropdown');

        this.emailInput = this.querySelector('input[type="email"]');
        this.checkInput = this.querySelector('input[type="checkbox"]');

        this.loader = this.querySelector('.loader');
        this.message = this.querySelector('.message');

        this.emailInput.addEventListener('input', () => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          this.isValid = pattern.test(this.emailInput.value);
        });

        this.btnSubmit = this.querySelector('button');
        this.btnSubmit.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSubmit();
        });

        if (this.variantSelects && this.variantSelects.dataset.handle === 'custom-shipping-boxes') {
          this.setupSizeValueObserver();
        }
      }

      setupSizeValueObserver() {
        if (!this.sizeDropdown) return;

        const observer = new MutationObserver(() => {
          if (this.sizeDropdown.dataset.value === 'custom') {
            this.setupCustomSizeObserver();
          } else {
            this.checkPredefinedSizeValidity();
          }
        });

        observer.observe(this.sizeDropdown, { attributes: true, attributeFilter: ['data-value'] });
      }

      setupCustomSizeObserver() {
        const customSizeForm = document.querySelector('.custom-size');
        if (!customSizeForm) return;

        const observer = new MutationObserver(() => {
          this.checkCustomSizeValidity();
        });

        observer.observe(customSizeForm, { attributes: true, childList: true, subtree: true });

        const lengthInput = customSizeForm.querySelector('#input-length');
        const widthInput = customSizeForm.querySelector('#input-width');
        const heightInput = customSizeForm.querySelector('#input-height');

        if (lengthInput && widthInput && heightInput) {
          lengthInput.addEventListener('input', () => this.checkCustomSizeValidity());
          widthInput.addEventListener('input', () => this.checkCustomSizeValidity());
          heightInput.addEventListener('input', () => this.checkCustomSizeValidity());
        }
      }

      checkCustomSizeValidity() {
        const customSizeForm = document.querySelector('.custom-size');
        if (!customSizeForm) return;

        const lengthInput = customSizeForm.querySelector('#input-length');
        const widthInput = customSizeForm.querySelector('#input-width');
        const heightInput = customSizeForm.querySelector('#input-height');

        if (!lengthInput || !widthInput || !heightInput) return;

        const length = parseFloat(lengthInput.value);
        const width = parseFloat(widthInput.value);
        const height = parseFloat(heightInput.value);

        const sizeIsValid = length <= 24 && width <= 24 && height <= 24;

        this.isValid = sizeIsValid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailInput.value);
      }

      checkPredefinedSizeValidity() {
        // Check predefined sizes which are always valid
        this.isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailInput.value);
      }

      get isValid() {
        return this._isValid;
      }

      set isValid(value) {
        this._isValid = value;

        if (this.variantSelects && this.variantSelects.dataset.handle === 'custom-shipping-boxes' && this.sizeDropdown && this.sizeDropdown.dataset.value === 'custom' && !this.isCustomSizeValid()) {
          this.btnSubmit.disabled = true;
        } else {
          this.btnSubmit.disabled = !value;
        }
      }

      isCustomSizeValid() {
        const customSizeForm = document.querySelector('.custom-size');
        if (!customSizeForm) return true;

        const lengthInput = customSizeForm.querySelector('#input-length');
        const widthInput = customSizeForm.querySelector('#input-width');
        const heightInput = customSizeForm.querySelector('#input-height');

        if (!lengthInput || !widthInput || !heightInput) return true;

        const length = parseFloat(lengthInput.value);
        const width = parseFloat(widthInput.value);
        const height = parseFloat(heightInput.value);

        return length <= 24 && width <= 24 && height <= 24;
      }

      get variantId() {
        if (!this.variantSelects || !this.variantSelects.currentVariant || !this.variantSelects.currentVariant.id) {
          return null;
        }

        return this.variantSelects.currentVariant.id;
      }

      get values() {
        if (!this.variantSelects || !this.variantSelects.values) {
          return null;
        }

        return this.variantSelects.values;
      }

      get boxType() {
        let boxType = this.dataset.boxType;

        // Remove dash
        boxType = boxType.replace(/-/g, ' ');

        // Capitalize first letter
        boxType = boxType.charAt(0).toUpperCase() + boxType.slice(1);

        return boxType;
      }

      async handleSubmit() {
        try {
          if (!this.isValid || this.fetching) return;

          this.fetching = true;
          this.showLoader();

          const baseUrl = new URL(`${window.internalApi.baseUrl}/designs/dieline`);

          const payload = {
            email: this.emailInput.value,
            subscribe: this.checkInput.checked,
            variantId: this.variantId,
            size: null,
          };

          if (this.values && this.values.size) {
            payload.size = this.values.size;
          }

          if (this.values && this.values.printing) {
            payload.printing = this.values.printing;
          }

          const searchParams = new URLSearchParams();
          for (const key in payload) {
            searchParams.append(key, payload[key]);
          }
          baseUrl.search = searchParams.toString();

          // fetch the blob containing the data
          const response = await fetch(baseUrl);

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const blob = await response.blob();

          // create a blob url representing the data
          const link = document.createElement('a');
          link.style.display = 'none';

          // set the the url of the link. It will be a blob url
          link.href = URL.createObjectURL(blob);

          // set the name of the downloaded file
          link.download = `Arka_${this.boxType}_${payload.size}_Dieline.zip`;

          // add the link to the document body
          document.body.appendChild(link);

          // trigger the download
          link.click();

          // clear the blob reference after some time to free up memory
          URL.revokeObjectURL(link.href);

          // remove the link when done
          document.body.removeChild(link);
          this.showMessage('Successfully downloaded!', 'success');
        } catch (error) {
          console.log(error);
          this.showMessage("Can't download, please try again. Verify size is not empty", 'error');
        } finally {
          this.fetching = false;
          this.hideLoader();
        }
      }

      showLoader() {
        if (this.loader) this.loader.style.display = 'block';
        if (this.message) this.message.style.display = 'none';
      }

      hideLoader() {
        if (this.loader) this.loader.style.display = 'none';
      }

      showMessage(text, type) {
        if (this.message) {
          this.message.textContent = text;
          this.message.style.display = 'block';
          this.message.style.color = type === 'success' ? 'green' : 'red';
        }
      }
    },
  );
}

if (!customElements.get('upload-dieline')) {
  customElements.define(
    'upload-dieline',
    class uploadDieline extends HTMLElement {
      constructor() {
        super();

        this.uploaded = null;
        this.maxFileSize = 100 * 1024 * 1024;

        this.variantSelects = document.querySelector('variant-selects');

        this.canvas = this.querySelector('canvas');
        this.pdfPreview = this.querySelector('.pdf-preview');
        this.formContainer = this.querySelector('.input-file');

        this.uploadBtn = this.querySelector('.upload-btn');
        if (this.uploadBtn) {
          this.uploadBtn.addEventListener('change', () => {
            if (this.uploadBtn.files) this.handleUpload(this.uploadBtn.files);

            this.uploadBtn.value = null;
          });
        }

        this.proofBtn = this.querySelector('.js-proof-design');
        if (this.proofBtn) {
          this.proofBtn.addEventListener('click', () => this.proofDesign());
        }

        this.dropArea = this.querySelector('.drop-area');
        if (this.dropArea) {
          this.dropArea.addEventListener('dragover', (e) => {
            e.preventDefault();
            this.dropArea.classList.add('dragover');
          });

          this.dropArea.addEventListener('dragleave', () => {
            this.dropArea.classList.remove('dragover');
          });

          this.dropArea.addEventListener('drop', (e) => {
            e.preventDefault();
            this.dropArea.classList.remove('dragover');

            this.handleUpload(e.dataTransfer.files);
          });
        }

        this.status = 'waiting';
      }

      get active() {
        return this.uploaded;
      }

      get status() {
        return this._status;
      }

      set status(status = 'waiting') {
        this._status = status;

        this.refresh();
      }

      get variantId() {
        if (!this.variantSelects || !this.variantSelects.currentVariant || !this.variantSelects.currentVariant.id) {
          return null;
        }

        return this.variantSelects.currentVariant.id;
      }

      get quantity() {
        if (!this.variantSelects || !this.variantSelects.quantity) {
          return 1;
        }

        return this.variantSelects.quantity;
      }

      get values() {
        if (!this.variantSelects || !this.variantSelects.values) {
          return null;
        }

        return this.variantSelects.values;
      }

      get properties() {
        if (!this.variantSelects || !this.variantSelects.properties) {
          return null;
        }

        return this.variantSelects.properties;
      }

      get productHandle() {
        if (!this.variantSelects || !this.variantSelects.productHandle) {
          return null;
        }

        return this.variantSelects.productHandle;
      }

      get isDoubleSided() {
        return this.variantSelects.doubleSidedPrinting;
      }

      refresh() {
        this.classList.toggle('waiting', this.status === 'waiting');
        this.classList.toggle('loading', this.status === 'loading');
        this.classList.toggle('loaded', this.status === 'loaded');

        /* Preview Current Item */
        if (this.status === 'loaded' && this.active) {
          this.pdfPreview.src = this.active.preview;
        } else {
          this.pdfPreview.src = '';
        }

        this.proofBtn.disabled = !this.active;
      }

      async handleUpload(files) {
        try {
          this.uploaded = null;

          this.status = 'loading';

          if (files.length > 1) {
            throw new Error('only allow upload 1 file');
          }

          const file = files[0] || null;
          if (!file || file.type !== 'application/pdf') {
            throw new Error('incorrect file format click to upload a new file');
          }

          if (file.size > this.maxFileSize) {
            throw new Error('File must be less than 100MB Click to upload a new file');
          }

          const pdfData = await this._fileToBuffer(file);

          pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

          const pdf = await pdfjsLib.getDocument(pdfData).promise;

          if (this.isDoubleSided && pdf.numPages !== 2) {
            throw new Error('The file must have 2 pages');
          }

          if (!this.isDoubleSided && pdf.numPages !== 1) {
            throw new Error('The file must have 1 page');
          }

          const page = await pdf.getPage(1);
          const viewport = page.getViewport({scale: 1});

          this.canvas.width = viewport.width;
          this.canvas.height = viewport.height;

          const renderContext = {
            viewport,
            canvasContext: this.canvas.getContext('2d'),
          };

          await page.render(renderContext).promise;

          this.uploaded = {
            name: file.name,
            size: file.size,
            type: file.type,
            data: await this._fileToBase64(file),
            preview: this.canvas.toDataURL('image/png'),
          };
        } catch (error) {
          this.showToast(error.message);
        } finally {
          if (!this.active) this.status = 'waiting';
          else this.status = 'loaded';
        }
      }

      async proofDesign() {
        try {
          this.status = 'loading';

          const baseUrl = new URL(`${window.internalApi.baseUrl}/designs/personalization-url`);

          const payload = {
            variantId: this.variantId,
            size: null,
          };

          if (this.values && this.values.size) {
            payload.size = this.values.size;
          }

          if (this.values && this.values.printing) {
            payload.printing = this.values.printing;
          }

          // check set exist customer user
          if (this.customerId && this.customerId !== '') {
            payload.customerId = this.customerId;
          }

          if (this.uploaded) {
            payload['validationPdf'] = this.uploaded.data;
          }

          const res = await fetch(baseUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          }).then((res) => res.json());

          if (!res.personalizationUrl) {
            let errorMessage = res.message || 'An error has occured. Please try again later.';

            // if error message contains 'Page size mismatch'
            if (errorMessage.includes('Page size mismatch')) {
              errorMessage = 'Box and file size do not match. Edit your size or upload a new file.';
            }

            throw new Error(errorMessage);
          }

          this.saveProductProperties();

          location.href = res.personalizationUrl;
        } catch (error) {
          this.showToast(error.message);
        } finally {
          if (!this.active) this.status = 'waiting';
          else this.status = 'loaded';
        }
      }

      async _fileToBuffer(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onerror = () => reject(null);
          reader.onload = () => {
            const pdfData = new Uint8Array(reader.result);

            resolve(pdfData);
          };

          reader.readAsArrayBuffer(file);
        });
      }

      async _fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = () => reject(null);

          reader.readAsDataURL(file);
        });
      }

      saveProductProperties() {
        this.properties['_purchases'] = 'design-dieline';

        const productJson = {
          id: this.variantId,
          quantity: this.quantity,
          properties: this.properties,
        };

        localStorage.setItem(`design_${this.variantId}`, JSON.stringify(productJson));
      }

      showToast(text) {
        const prevToast = this.formContainer.querySelector('.item-error-upload');
        if (prevToast) this.formContainer.removeChild(prevToast);

        const toastUploadDiv = document.createElement('div');
        toastUploadDiv.classList.add('item-error-upload');
        toastUploadDiv.textContent = text;

        this.formContainer.appendChild(toastUploadDiv);

        setTimeout(() => {
          this.formContainer.removeChild(toastUploadDiv);
        }, 5000);
      }

      reset() {
        this.uploaded = null;
        this.status = 'waiting';
      }
    },
  );
}

if (!customElements.get('modal-dieline')) {
  customElements.define(
    'modal-dieline',
    class ModalDieline extends HTMLElement {
      constructor() {
        super();

        this.variantSelects = document.querySelector('variant-selects');
        this.sizeDropdown = document.querySelector('size-dropdown');

        this.openBtn = document.querySelector('.open-modal-dieline');

        this.openBtns = document.querySelectorAll('.open-modal-dieline');
        this.HTMLElement = document.querySelector('html');

        if (this.openBtns) {
          this.openBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();

              const dataStep = btn.getAttribute('data-step');
              if (dataStep) {
                const stepIndex = parseInt(dataStep) - 1; // Subtract 1 since steps are zero-based
                this.open(stepIndex);
                this.HTMLElement.classList.add('overflow-hidden');
              } else {
                this.open();
              }
            });
          });
        }

        this.closeBtn = this.querySelectorAll('.js-close-modal-dieline');
        if (this.closeBtn && this.closeBtn.length > 0) {
          this.closeBtn.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();

              this.close();
              this.HTMLElement.classList.remove('overflow-hidden');
            });
          });
        }

        this.editBtn = this.querySelectorAll('.js-edit');
        if (this.editBtn && this.editBtn.length > 0) {
          this.editBtn.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();

              this.edit();
            });
          });
        }

        window.addEventListener('click', (e) => {
          if (e.target === this) {
            this.close();
            this.HTMLElement.classList.remove('overflow-hidden');
          }
        });

        this.steps = this.querySelectorAll('.content-step');
        this.steps.forEach((step, index) => {
          step.querySelector('.title').addEventListener('click', () => {
            this.changeStep(index);
          });
        });

        this.sizesElm = this.querySelectorAll('.js-size');
        this.printingElem = this.querySelectorAll('.js-printing');

        this.uploadDieline = this.querySelector('upload-dieline');

        this.setupCustomSizeObserver();
      }

      setupCustomSizeObserver() {
        const customSizeForm = document.querySelector('.custom-size');
        if (!customSizeForm) return;

        const observer = new MutationObserver(() => {
          this.updateProductSize();
        });

        observer.observe(customSizeForm, { attributes: true, childList: true, subtree: true });

        const lengthInput = customSizeForm.querySelector('#input-length');
        const widthInput = customSizeForm.querySelector('#input-width');
        const heightInput = customSizeForm.querySelector('#input-height');

        if (lengthInput && widthInput && heightInput) {
          lengthInput.addEventListener('input', () => this.updateProductSize());
          widthInput.addEventListener('input', () => this.updateProductSize());
          heightInput.addEventListener('input', () => this.updateProductSize());
        }
      }

      get values() {
        if (!this.variantSelects || !this.variantSelects.values) return {};

        return this.variantSelects.values;
      }

      open(stepIndex) {
        this.updateProductSize();
        if (this.uploadDieline) {
          this.uploadDieline.reset();
        }

        this.classList.add('active');
        if (stepIndex !== undefined) {
          this.changeStep(stepIndex);
        }
      }

      edit() {
        this.close();

        setTimeout(() => {
          this.sizeDropdown.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
          this.sizeDropdown.open();
        }, 500);
      }

      close() {
        this.classList.remove('active');
        this.HTMLElement.classList.remove('overflow-hidden');
      }

      changeStep(step) {
        this.steps.forEach((step) => {
          step.classList.remove('active');
        });

        this.steps[step].classList.add('active');
      }

      updateProductSize() {
        const { size, printing } = this.values || {};

        const lengthInput = document.querySelector('#input-length');
        const widthInput = document.querySelector('#input-width');
        const heightInput = document.querySelector('#input-height');

        let boxSize;

        if (this.sizeDropdown && this.sizeDropdown.dataset.value === 'custom' && lengthInput && widthInput && heightInput) {
          const length = lengthInput.value || '0';
          const width = widthInput.value || '0';
          const height = heightInput.value || '0';
          boxSize = `${length}x${width}x${height}`;
        } else {
          boxSize = size;
        }

        if (this.sizesElm && this.sizesElm.length > 0) {
          this.sizesElm.forEach((sizeElm) => {
            const content = sizeElm.querySelector('p');
            if (boxSize && content) {
              content.innerHTML = boxSize;
            }

            sizeElm.classList.toggle('hidden', !boxSize);
          });
        }

        if (this.printingElem && this.printingElem.length > 0) {
          this.printingElem.forEach((printingElm) => {
            const content = printingElm.querySelector('p');
            if (printing && content) {
              content.innerHTML = printing;
            }

            printingElm.classList.toggle('hidden', !printing);
          });
        }
      }
    },
  );
}
